export const isPickPack = (item) => item.idProductType === 6;